module.exports = __webpack_public_path__ + "img/FAQ.6263e2e0.png";